import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap';

const ModalCrearCoMaedcv = ({ isOpen, toggle, onSave }) => {
    const [formData, setFormData] = useState({
        CLAEMP: '',
        TIPFOL: '',
        NUMFOL: '',
        // Add other fields as needed
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = () => {
        onSave(formData);
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Crear Registro CO_MAEDCV</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="CLAEMP">Empresa</Label>
                        <Input type="number" name="CLAEMP" id="CLAEMP" value={formData.CLAEMP} onChange={handleChange} />
                    </FormGroup>
                    <FormGroup>
                        <Label for="TIPFOL">Tipo Folio</Label>
                        <Input type="text" name="TIPFOL" id="TIPFOL" value={formData.TIPFOL} onChange={handleChange} />
                    </FormGroup>
                    <FormGroup>
                        <Label for="NUMFOL">Número Folio</Label>
                        <Input type="number" name="NUMFOL" id="NUMFOL" value={formData.NUMFOL} onChange={handleChange} />
                    </FormGroup>
                    {/* Add more fields here as needed */}
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleSubmit}>Guardar</Button>
                <Button color="secondary" onClick={toggle}>Cancelar</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalCrearCoMaedcv;